import { ReactNode } from 'react';

import { SnackbarProvider } from 'notistack';

import { AlertType } from '@/shared/types/Alert';

import { AlertContainer } from './AlertContainer';

type NotificationsProps = {
  children: ReactNode;
};

export const Notifications = ({ children }: NotificationsProps) => {
  return (
    <SnackbarProvider
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'top',
      }}
      Components={{
        error: AlertContainer,
        info: AlertContainer,
        success: AlertContainer,
        warning: AlertContainer,
      }}
      maxSnack={2}
      variant={AlertType.Error}
    >
      {children}
    </SnackbarProvider>
  );
};
